import { SHOOTS_FETCH_REQUEST, SHOOTS_FETCH_SUCCESS, SHOOTS_FETCH_FAILURE } from './types';

const initialState = {
    loading: false,
    shoots: {},
    error: ''
}

const shoots = (state = initialState, action) => {
    switch (action.type) {
        case SHOOTS_FETCH_REQUEST:
            return {
                loading: true,
                shoots: {},
                error: '',
            }
        case SHOOTS_FETCH_SUCCESS:
            return {
                loading: false,
                shoots: action.payload,
                error: ''
            }
        case SHOOTS_FETCH_FAILURE:
            return {
                loading: false,
                shoots: {},
                error: action.payload
            }
        default: return state
    }
}

export default shoots;